import { render, staticRenderFns } from "./FichaCreaCategoria.vue?vue&type=template&id=706ae536"
import script from "./FichaCreaCategoria.vue?vue&type=script&lang=js"
export * from "./FichaCreaCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports